import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  useMediaQuery,
  Avatar,
  CardHeader,
  Tooltip,
} from "@mui/material";
import {
  useGetAllPurchaseDhashboardFristQuery,
  useGetPositionQuery,
  useGetMissingPunchOutQuery,
  useGetTeamQuery,
  useGetPunchDashboardQuery,
  useGetOutOfLocationQuery,
} from "../../Api/attoDeskApi";
import {
  IPosition,
  ITeam,
  IPunchEmpRecord,
  historyPuncRecord,
} from "../../Api/Interface/api.interface";
import useDebounce from "../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Groups2Icon from "@mui/icons-material/Groups2";
import useIsMobile from "../../Core/hook/useIsMobile";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ChecklistIcon from "@mui/icons-material/Checklist";
import OrderListStatusBarChart from "./Component/orderListStatusBarChart";
import OrderListSuppliertimelinechart from "./Component/OrderListSuppliertimelinechart";
import LastUpdateOrderList from "./Component/lastUpdateOrderList";
import TopOrderProducttable from "./Component/topOrderProducttable";
import StoreBarChart from "./Component/storeBarChar";
import CategoryProductPieChart from "./Component/categoryProductPieChart";

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedCilent, setSelectedClient] = useState<string | "">("");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { data: clientData, isLoading: clientIsLoading } =
    useGetAllPurchaseDhashboardFristQuery({
      id: "",
    });

  if (clientIsLoading) {
    return (
      <Box p={isMobile ? 2 : 1}>
        <Grid container spacing={2}>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              {[...Array(3)].map((_, index) => (
                <Grid
                  item
                  md={4}
                  sm={12}
                  xs={12}
                  lg={12}
                  key={`top-skeleton-${index}`}
                >
                  <Skeleton
                    variant="rectangular"
                    // height={200}
                    height={isMobile ? 50 : 100}
                    animation="wave"
                    className={classes.dhashboardCardSkeleton}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item lg={8} md={12} sm={12} xs={12}>
            <Skeleton
              variant="rectangular"
              // height={200}
              height={isMobile ? 100 : "100%"}
              animation="wave"
              className={classes.dhashboardCardSkeleton}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 100 : 300}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={4} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 100 : 300}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <div>
      <Grid container>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            padding: isMobile ? 1 : 2,
            minHeight: "100vh",
            borderRadius: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.purdashboardfristCardButtonText1}
                        >
                           Order
                        </Typography>
                        <Typography
                          className={classes.purdashboardfristCardButtonText2}
                        >
                          {clientData?.data.total_order ?? "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.purdashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <ChecklistIcon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.purdashboardfristCardButtonText1}
                        >
                          Products
                        </Typography>
                        <Typography
                          className={classes.purdashboardfristCardButtonText2}
                        >
                          {clientData?.data.total_product ?? "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.purdashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <ShoppingCartIcon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.purdashboardfristCardButtonText1}
                        >
                          Supplier
                        </Typography>
                        <Typography
                          className={classes.purdashboardfristCardButtonText2}
                        >
                          {clientData?.data.total_supplier ?? "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.purdashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <Groups2Icon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.purdashboardfristCardButtonText1}
                        >
                          Supplier
                        </Typography>
                        <Typography
                          className={classes.purdashboardfristCardButtonText2}
                        >
                          {clientData?.data.total_supplier ?? "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.purdashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <Groups2Icon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={8} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ height: "100%", maxHeight: "480px" }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className={classes.dashboardfristCardHeading}>
                      Order List Status
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <OrderListStatusBarChart />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ height: "100%" }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className={classes.dashboardfristCardHeading}>
                      Supplier Order Performance Overview
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <OrderListSuppliertimelinechart />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ height: "100%" }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className={classes.dashboardfristCardHeading}>
                      Product Availability per Store
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <StoreBarChart />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ height: "100%" }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className={classes.dashboardfristCardHeading}>
                      Category Variant Overview
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <CategoryProductPieChart />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ height: "100%" }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className={classes.dashboardfristCardHeading}>
                      Recent Order Activity
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <LastUpdateOrderList />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ height: "100%" }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className={classes.dashboardfristCardHeading}>
                      Most Ordered Product
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TopOrderProducttable />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
